var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "ul",
    { staticClass: "my-list" },
    _vm._l(_vm.lists, function(item, index) {
      return _c(
        "li",
        {
          key: index,
          on: {
            click: function($event) {
              return _vm.onJumpto(item)
            }
          }
        },
        [
          _c(
            "span",
            { staticClass: "avatar" },
            [
              _c("el-badge", { attrs: { value: item.unreadAmount, max: 99 } }, [
                _c("img", {
                  attrs: { src: _vm.image.groupAvatar, alt: "avatar" }
                })
              ])
            ],
            1
          ),
          _vm._v(" "),
          _c("span", { staticClass: "title" }, [
            _vm._v(_vm._s(item.groupTitle))
          ])
        ]
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-00a5e24f", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-00a5e24f","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/basic/popover/popoverContent.vue
// module id = null
// module chunks = 